import React, { useEffect } from "react";

export default function AboutUs() {
  useEffect(() => {
    document.title = "เกี่ยวกับ Encraft - Encraft";
  }, []);

  return (
    <div className="content-container">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <h1 className="mb-3">เกี่ยวกับ Encraft</h1>
            <p className="text-muted mb-4">
              เรียนรู้ เขียน แบ่งปัน และต่อยอดความรู้ด้านเทคโนโลยีและ AI ไปด้วยกัน
            </p>

            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">เราเป็นใคร</h2>
                <p>
                  <strong>Encraft</strong> คือแพลตฟอร์มบทความและพื้นที่เรียนรู้
                  ที่มุ่งเน้นเรื่อง <strong>AI</strong> และการนำเทคโนโลยีมาใช้พัฒนาการทำงาน
                  ชีวิต และธุรกิจให้มีประสิทธิภาพมากขึ้น
                </p>
                <p>
                  เราอยากให้ encraft.org เป็นเหมือน &quot;คลังความรู้&quot; +
                  &quot;ห้องทดลอง&quot; สำหรับคนที่สนใจเรื่อง AI และการทำงานแบบอัตโนมัติ
                  ไม่ว่าจะเป็นผู้เริ่มต้น ฝั่งผู้ใช้งานสายอาชีพ หรือสายพัฒนา (Developer)
                </p>
              </div>
            </div>

            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">เราโฟกัสเรื่องอะไร</h2>
                <ul>
                  <li>บทความด้าน AI, Prompt Engineering, AI Tools</li>
                  <li>การใช้งาน Automation เช่น n8n, Zapier, Make, Google Apps Script</li>
                  <li>ตัวอย่างการนำ AI ไปใช้กับงานจริงในสายอาชีพต่าง ๆ</li>
                  <li>การทดลองและพัฒนา AI Agent / Workflow ที่ใช้งานได้จริง</li>
                </ul>
                <p className="mb-0">
                  ทั้งหมดนี้อยู่ในรูปแบบบทความที่อ่านง่าย
                  พร้อมตัวอย่างและแนวคิดที่นำไปต่อยอดได้ทันที
                </p>
              </div>
            </div>

            <div className="card border mb-4">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">EnChat – ผู้ช่วย AI บนเว็บไซต์</h2>
                <p>
                  บนบทความในเว็บไซต์ คุณจะพบกับปุ่ม{" "}
                  <strong>EnChat (AI Chat)</strong> ซึ่งเป็นผู้ช่วย AI
                  ที่ถูกออกแบบมาเพื่อช่วยตอบคำถามและอธิบายเนื้อหาที่เกี่ยวข้องกับบทความ
                  หรือหัวข้อที่คุณกำลังสนใจอยู่
                </p>
                <p>
                  ในช่วงแรก EnChat จะเน้นช่วยตอบคำถามเกี่ยวกับบทความและเนื้อหาในเว็บ
                  พร้อมขยายไปสู่การช่วยคิด workflow, ไอเดีย และตัวอย่างการประยุกต์ใช้ AI
                  ในชีวิตจริงในลำดับถัดไป
                </p>
                <p className="mb-0">
                  หากอยากรู้รายละเอียดเชิงเทคนิคมากขึ้น
                  คุณสามารถอ่านได้ที่หน้า{" "}
                  <a href="/enchat">ข้อมูลเกี่ยวกับ EnChat (AI Chat)</a>.
                </p>
              </div>
            </div>

            <div className="card border">
              <div className="card-body p-4 p-md-5">
                <h2 className="h5 mb-3">แนวทางการพัฒนาในอนาคต</h2>
                <ul>
                  <li>ระบบบทความที่ครบถ้วนและค้นหาได้ง่าย</li>
                  <li>พื้นที่สำหรับจำหน่าย eBook และคอร์สเรียนออนไลน์</li>
                  <li>ฟีเจอร์สำหรับ Creator/ผู้เขียน ที่บริหารผลงานของตัวเองได้สะดวก</li>
                  <li>ชุมชนสำหรับแลกเปลี่ยนไอเดียด้าน AI และ Automation</li>
                </ul>
                <p className="mb-0">
                  หากคุณสนใจร่วมเขียน ร่วมพัฒนา หรืออยากเสนอไอเดียเพิ่มเติม
                  สามารถติดต่อเราได้ที่หน้า{" "}
                  <a href="/contact">ติดต่อเรา</a>.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
